"use strict";

exports.__esModule = true;
var PlayerState;

(function (PlayerState) {
  PlayerState["STOPPED"] = "STOPPED";
  PlayerState["LOADING"] = "LOADING";
  PlayerState["LOADED"] = "LOADED";
  PlayerState["PLAYING"] = "PLAYING";
  PlayerState["PAUSED"] = "PAUSED";
  PlayerState["ENDED"] = "ENDED";
  PlayerState["BUFFERING"] = "BUFFERING";
  PlayerState["SEEKING"] = "SEEKING";
})(PlayerState || (PlayerState = {}));

exports.isPaused = function (state) {
  return state === PlayerState.PAUSED || state === PlayerState.LOADED || state === PlayerState.LOADING || state === PlayerState.STOPPED || state === PlayerState.ENDED;
};

exports.isPlayerState = function (state) {
  return typeof state === 'string' && (state === PlayerState.STOPPED || state === PlayerState.LOADING || state === PlayerState.LOADED || state === PlayerState.PLAYING || state === PlayerState.PAUSED || state === PlayerState.ENDED || state === PlayerState.BUFFERING || state === PlayerState.SEEKING);
};

exports["default"] = PlayerState;